module.exports = __webpack_public_path__ + "img/powerpoint.81fae890.png";